import type { LectureRevision } from "./lecture-plan";

export type RevisionTone = "today" | "carried" | "completed" | "upcoming";

export function revisionTone(revision: LectureRevision, today: string): RevisionTone {
  if (revision.status === "completed") return "completed";
  if (revision.dueDate < today) return "carried";
  if (revision.dueDate === today) return "today";
  return "upcoming";
}

export const TONE_CLASSES: Record<RevisionTone, string> = {
  today: "border-primary/40 bg-primary/12 text-primary",
  carried: "border-warning/40 bg-warning/12 text-warning",
  completed: "border-success/40 bg-success/12 text-success",
  upcoming: "border-lime-400/40 bg-lime-400/10 text-lime-400",
};

export const TONE_LABEL: Record<RevisionTone, string> = {
  today: "Today's revision",
  carried: "Carried forward",
  completed: "Completed",
  upcoming: "Upcoming",
};

export const REVISION_LEGEND = [
  { dot: "bg-primary", label: "Today's" },
  { dot: "bg-success", label: "Completed" },
  { dot: "bg-warning", label: "Carried" },
  { dot: "bg-lime-400", label: "Upcoming" },
] as const;

/** 1 -> "1st Revision", 4 -> "4th Revision (final reinforcement)". */
export function ordinal(n: number): string {
  const rest = n % 100;
  if (rest >= 11 && rest <= 13) return `${n}th`;
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}

export function revisionRoundLabel(n: number): string {
  return `${ordinal(n)} Revision`;
}